import { render, staticRenderFns } from "./WaterFallSlide.vue?vue&type=template&id=8670669a&"
import script from "./WaterFallSlide.vue?vue&type=script&lang=js&"
export * from "./WaterFallSlide.vue?vue&type=script&lang=js&"
import style0 from "./WaterFallSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports